export const GET_PROJECTS_REQUEST = "GET_PROJECTS_REQUEST";
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS";
export const GET_PROJECTS_FAILURE = "GET_PROJECTS_FAILURE";

export const GET_SUPPORTED_PROJECTS_REQUEST = "GET_SUPPORTED_PROJECTS_REQUEST";
export const GET_SUPPORTED_PROJECTS_SUCCESS = "GET_SUPPORTED_PROJECTS_SUCCESS";
export const GET_SUPPORTED_PROJECTS_FAILURE = "GET_SUPPORTED_PROJECTS_FAILURE";